import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetSportProvidersByShortNamesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
	platform: Types.Platform;
}>;

export type GetSportProvidersByShortNamesQuery = { __typename?: 'Query' } & {
	packages: Array<{ __typename?: 'Package' } & Pick<Types.Package, 'packageId' | 'shortName' | 'clearName'>>;
};

export const GetSportProvidersByShortNamesDocument = gql`
	query GetSportProvidersByShortNames($country: Country!, $platform: Platform!) {
		packages(country: $country, platform: $platform, hasSport: true) {
			packageId
			shortName
			clearName
		}
	}
`;
